import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { Trans } from "react-i18next";
import Select from "react-select";
import ls from "local-storage"; 
import { options } from "../../config/options";
import "../../config/i18n";
import { withTranslation } from "react-i18next";  

import Cookies from 'universal-cookie';
import FacebookLogin from 'react-facebook-login';
import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from '../../firebaseConfig';

class Welcome extends Component {
	constructor(props) {
        super(props);
        // console.log("apiii"+localStorage.getItem('api_url'));
        this.state = {
        	api_url:localStorage.getItem('api_url'),
        	lang: ls.get('LangKeySet') || options[0],
         langKey: ls.get('LangValue')
        };
      }
   
   	changeLang = lang => {
		const { i18n } = this.props;
		const { value } = lang;
		this.setState({
			lang
		});
		ls.set('LangKeySet', lang);
        ls.set('LangValue', value);
		i18n.changeLanguage(value);
		window.location.reload();    
	};

	componentDidMount(){
		if (this.props.i18n.language) {
			this.setState(
				{
					lang: options.filter(item => item.value === this.props.i18n.language)
				},
				() => console.log(this.state)
			);
		}

		const cookies = new Cookies();
	   if(cookies.get('onboarded') === 'true'){
		 //alert("s");
		 this.props.history.push("/app")
		   
		 
		}else{
		//  this.props.history.push("/login");
		//  window.location.reload();

		}
    }
   
	googleLogin = () => {
		if (!firebase.apps.length) {
			firebase.initializeApp(firebaseConfig);
		}
		const provider = new firebase.auth.GoogleAuthProvider();
		provider.setCustomParameters({ prompt: 'select_account' });

		firebase.auth().signInWithPopup(provider).then((result) => {
			const user = result.user;
			if (user.email && user.uid) {
				const googleId = user.providerData[0].uid || user.uid;
				const email = user.email;
				const name = user.displayName;
				const picture = user.photoURL;

				const cookies = new Cookies();
				var formdata = new FormData();
				formdata.set('email', email);
				formdata.set('googleid', googleId);
				formdata.set('language', this.state.langKey);  
				
				axios({
					method: 'post',
					url: localStorage.getItem('api_url') + 'check_google_user',
					data: formdata,
					config: { headers: {'Content-Type': 'multipart/form-data' }}
				}).then(res => {
					var hosturl = window.location.href;
					if (res.data === 0) {
						cookies.set('googleemail', email);
						formdata.set('fcmtoken', cookies.get('mytoken'));
						formdata.set('language', this.state.langKey);  
						axios({
							method: 'post',
							url: localStorage.getItem('api_url') + 'webemaillogin',
							data: formdata,
							config: { headers: {'Content-Type': 'multipart/form-data' }}
						}).then(res => {
							var loginstatus = new FormData();
							loginstatus.set('user_id', res.data.peoples.user_id);
							loginstatus.set('status', '1');
							loginstatus.set('language', this.state.langKey);    
							axios({
								method: 'post',
								url: localStorage.getItem('api_url') + 'webonlinestatus',
								data: loginstatus,
								config: { headers: {'Content-Type': 'multipart/form-data' }}
							});
							
							let d = new Date();
							d.setTime(d.getTime() + (12*60*60*1000));   
							cookies.set('onboarded', 'true', {path: "/", expires: d});
							localStorage.setItem('session_token', JSON.stringify(res.data.peoples.token));
							localStorage.setItem('session_userid', JSON.stringify(res.data.peoples.user_id));
							sessionStorage.setItem('loggedin', 'true');
							window.location.href = hosturl + "app/PeopleNear";
						});
					} else if (res.data === 1) {
						cookies.set('googleemail', email);
						cookies.set('googleid', googleId);
						cookies.set('googlename', name);
						cookies.set('googlepic', picture);
						cookies.set('signuptab', 'yes');
						window.location.href = hosturl + "login";
					}
				});
			}
		}).catch((error) => {
			console.log("Google Auth Error:", error);
		});
	};

   responseFacebook(response) {
	// console.log(localStorage.getItem('api_url'));
	// console.log(response);
	//return false;
	const cookies = new Cookies();
	if(response.email && response.userID){
		/*accessToken: "EAAN0Vvn2g1ABAEIKMzjnh46rpdVajRSPZCrx7mGewml2GLSzr4Knl0b3mi2DWFoSGFxTmNbeWy2vimZBG8XuV6WUqiHKXTLTbAHEfUvY5tOpGSDPu7uhFAHFHuADFrUhml6o8zZBEuBvQFBwTQ1czz9WZBbKSlPr3VTV1s4j8IZAH0WQfL7MXq1zaqIg60MzZCdP0s4DGGAwZDZD"
		data_access_expiration_time: 1568277380
		email: "eceji007@gmail.com"
		expiresIn: 5020
		id: "2504514599572933"
		name: "Balaji Bala"
		picture: {data: {…}}
		reauthorize_required_in: 7776000
		signedRequest: "24Fk7AAv8tv_z3fOTodKAQm2Wlr1SaDx3Mo5UWatweI.eyJ1c2VyX2lkIjoiMjUwNDUxNDU5OTU3MjkzMyIsImNvZGUiOiJBUUI4aEFZeTh2bGgyZDdTNlNDMzRmZFZpXzV3X2Y5UnRNckpxREF6SU9DTUJrSkdTT1ZDTUJEWGJ4VmVnR2NpZkprNE96RENNTm9ZQVplV0NpUEZQcmtSNEFwaVpCY0JvTnFVNVhHVHM1bWtzTnBTbjVNaXNYVUZtVlFKdmdrbklSUkRQM3lHUXNuMkVkU19jcU4wUW0zTEVib1dIV3Vjb200aXV4YmhfOU1xYVJUeUhXRF9tZjBfbDVFaDVJQUFDWjAtdERLVXZiWm9sem5QSlp0cGxZYXgzUzhvUDdocVhDTVVfX2JJWXdBcG9UZjdRSEN5aEFMLWVNQmRMc2lGUG4yZVRmV29WMlZMM0ZaTXNQcHc5XzQzeG5lY2RXcERKa0xfQkZ2bDQyWVhndzJtY0RRWjBoanZtaXNKMkcxRVRpSS05SlduTGliZDhyLWppbkJ3U1lxOCIsImFsZ29yaXRobSI6IkhNQUMtU0hBMjU2IiwiaXNzdWVkX2F0IjoxNTYwNTAxMzgwfQ"
		userID: "2504514599572933"*/
		var formdata = new FormData();
        formdata.set('email', response.email);
        formdata.set('fbid', response.userID);
        formdata.set('language', this.state.langKey);  
        axios({
            method: 'post',
            url: localStorage.getItem('api_url')+'check_fb_user',
            data: formdata,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
            	// console.log(res.data);
            	var hosturl = window.location.href;
            	
                	
            	if(res.data===0){
            		cookies.set('fbemail', response.email);
            		formdata.set('fcmtoken', cookies.get('mytoken'));
            		formdata.set('language', this.state.langKey);  
            		axios({
			            method: 'post',
			            url: localStorage.getItem('api_url')+'webemaillogin',
			            data: formdata,
			            config: { headers: {'Content-Type': 'multipart/form-data' }}
			            }).then(res => {
			            	// console.log(res.data);
			            	var loginstatus = new FormData();
							loginstatus.set('user_id', res.data.peoples.user_id);
							loginstatus.set('status', '1');
							loginstatus.set('language', this.state.langKey);    
							axios({
									method: 'post',
									url: localStorage.getItem('api_url')+'webonlinestatus',
									data: loginstatus,
									config: { headers: {'Content-Type': 'multipart/form-data' }}
									})
									
							let d = new Date();
							d.setTime(d.getTime() + (12*60*60*1000));   
							cookies.set('onboarded', 'true', {path: "/", expires: d});
							// console.log("cookies1",cookies.get('onboarded'));	 				
							localStorage.setItem('session_token',JSON.stringify(res.data.peoples.token));
							localStorage.setItem('session_userid',JSON.stringify(res.data.peoples.user_id));
							sessionStorage.setItem('loggedin', 'true');
							window.location.href = hosturl+"app/PeopleNear";
							//this.props.history.push("/app")
			            })

            	}else if(res.data===1){
            		cookies.set('fbemail', response.email);
					cookies.set('fbid', response.userID);
					cookies.set('fbname', response.name);
					cookies.set('fbpic', response.picture.data.url);
					cookies.set('signuptab', 'yes');
					//this.props.history.push("/login");
                	window.location.href = hosturl+"login";
                	/*var element = document.getElementById("signin-link");
  					element.classList.remove("active");

                	var element = document.getElementById("signup-link");
  					element.classList.add("active");*/
  					//$('.signInForms > nav-tabs > nav-item >#signin-link').removeClass('active'); 
                }
            })

	}
  }


	render() {
		const { lang } = this.state;  
		var hosturl = window.location.href;
		var phoneloginURL = hosturl+"phonelogin";
		return (

			<div className="welcomePage">
				
				<div className="col-12">
						<div className="apt20 apb5">  
							<div style={{ width: "150px" }}> 
								<Select
					            defaultValue={lang} 
					            options={options}
					            value={lang}
					            onChange={this.changeLang} 
					            className="App-Select"
					          />
							</div>
						</div>
					</div> 


				<div className="welcomePageCenterContent">

					<div className="welcomeLogo"></div>

					<div id="welcome" class="carousel slide amt40 amb10" data-ride="carousel">
						<ul class="carousel-indicators"><li data-target="#welcome" data-slide-to="0" class=""></li>
							<li data-target="#welcome" data-slide-to="1" class=""></li>
							<li data-target="#welcome" data-slide-to="2" class="active"></li></ul>
						<div class="carousel-inner">
							<div class="carousel-item text-center">
								<h4 class="amb15 white-color"><Trans i18nKey="Matches near you">Matches near you</Trans></h4>
								<p class="white-color amb50 sma-16"><Trans i18nKey="welcomeSlide1">We make it easy to navigate into the online dating world by making it a comfortable and fun experience</Trans></p>
							</div>
							<div class="carousel-item text-center">
								<h4 class="amb15 white-color"><Trans i18nKey="Swipe for more">Swipe for more</Trans></h4>
								<p class="white-color amb50 sma-16"><Trans i18nKey="welcomeSlide2">We helps you to find your soulmate who is just a few swipes away from you. Connect with people no matter where you are.</Trans></p>
							</div>
							<div class="carousel-item text-center active"> 
								<h4 class="amb15 white-color"><Trans i18nKey="Find the People near you">Find the People near you</Trans> </h4> 
								<p class="white-color amb50 sma-16"><Trans i18nKey="welcomeSlide3">Choose those who you are compatible can message you. So just say hi and find your next date.</Trans></p>
							</div>
						</div>
					</div> 

						<div className="w-100">
						{/* <FacebookLogin
						appId="421069372229843"
						autoLoad={false}
						textButton= {<Trans i18nKey="Login with Facebook">Login with Facebook</Trans>}
						fields="name,email,picture.width(400).height(400)"
						//scope="public_profile,user_friends,email"
						cssClass="btnsWelcome white-border border-radius text-light white-border"
						callback={this.responseFacebook}  
						/> */}
						<button 
							onClick={this.googleLogin} 
							className="btnsWelcome white-border border-radius text-light white-border google-btn"
							style={{ 
								display: 'flex', 
								alignItems: 'center', 
								justifyContent: 'center', 
								background: 'transparent', 
								cursor: 'pointer',
								width: '100%',
								border: '1px solid #fff',
								color: '#fff',
								outline: 'none'
							}}
						>
							<Trans i18nKey="Login with Google">Login with Google</Trans>
						</button>
						</div>      

					<NavLink to="/login" className="btnsWelcome border-radius  white-border text-dark white-bg"> <Trans i18nKey="LoginwithMailid">Login with Mail id</Trans> </NavLink>
					{/* <a href={phoneloginURL} className="btnsWelcome white-border border-radius text-light white-border"> <Trans i18nKey="LoginwithMobile">Login with Mobile</Trans> </a> */}
 
					<div class="white-color esmh-14 text-center amt10"><Trans i18nKey="signingIn"><span className="floating-label">By signing in, you agree with our</span> </Trans>
					  <span> <NavLink to="/helpmain" className="text-bold white-color"> <Trans i18nKey="TermsandConditions"><span className="floating-label">Terms and Conditions</span> </Trans> </NavLink></span></div>

				</div> 




			</div>

		);
	}

}




export default withTranslation("translations")(Welcome);
